<template>
    <div>
        <compFormEdit
            class="clearfix"
            ref="dataForm"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="100"
        />
        <div class="tip-container" v-html="$t('erp.distribution.cancel_attention_tip', { defaultValue: '<p>注意：</p><p>1.已推送的配货单取消会向系统对接的仓库请求取消，异步对接的请及时确认取消结果；</p><p>2.系统没有对接的仓库，需要到仓库系统取消仓库单据；</p><p>3.配货单取消后状态不能恢复，请谨慎操作。</p>' })">
        </div>
        <div class="btn-container" style="text-align: right; margin-bottom: 20px; padding-right: 60px;">
            <Button type="warning" style="margin-right: 15px;" @click="submit">{{$t('erp.distribution.confirm_submit', { defaultValue: '确认提交' })}}</Button>
            <Button @click="$emit('on-close')">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button>
        </div>
    </div>
</template>

<script>
import { HttpCancelDistribution } from '@/service/boss/distribution'
export default {
    props: ['activeid'],
    components: {
        compFormEdit: () => import("@components/templates/formedit"),
    },
    watch: {
        activeid: {
            immediate: true,
            handler (newId) {
                this.deliverOrderIds = newId;
            }
        }
    },
    data () {
        return {
            formData: {
                deliverOrderIds: this.activeid,
                cancelReason: 1
            }
        }
    },
    computed: {
        getBase () {
            return [
                // {
				// 	label: "取消原因",
				// 	key: "cancelReason",
                //     tag: "vSelect",
                //     span: 20,
				// 	required: true,
				// 	options: [{
                //         value: 1,
                //         label: '仓库原因'
                //     }, {
                //         value: 2,
                //         label: '非仓库原因'
                //     }]
				// },
				{
					label: this.$t('global.common.notes', { defaultValue: "备注" }),
					tag: "vTextarea",
                    key: "remark",
                    span: 20,
					required: false,
                }
            ]
        }
    },
    methods: {
        async submit () {
            let flag = true
            await this.$refs.dataForm.validate(valid => {
                if (!valid) {
                    this.$VMessage.error(this.$t('global.common.fill_required', { defaultValue: '请填写必填项' }))
                    return flag = false
                }
            })
            if (!flag) return
            
            HttpCancelDistribution(this.formData).then(res => {
                this.$VMessage.success(res.message)
                this.$emit('on-close')
                this.$emit('on-update')
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        }
    }
}
</script>

<style scoped>
.tip-container {
    color: #ed4014;
    margin-left: 20px;
}
</style>